import {apiClient} from '@/services/base/BaseService';
import {IProduct} from '@/models/IProduct';

export async function getListProducts(organizationId: number, shopId: number) {
    const res = await apiClient.get(`organizations/${organizationId}/shops/${shopId}/products`);
    return res.data.data as IProduct[];
}
